var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBkp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.38 171.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4b200;}.cls-2{fill:#fff;}.cls-3,.cls-5{fill:none;stroke:#000;}.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4.26px;}.cls-4{fill:#7b320b;}.cls-5{stroke-miterlimit:10;stroke-width:0.84px;}.cls-6{fill:#a34e0f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fichier 1BEKEEPER_Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.24,
    width: 142.38,
    height: 142.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.32,
    cy: 69.31,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.09,
    cy: 61.24,
    r: 4.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.29,
    cy: 69.04,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.06,
    cy: 60.97,
    r: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.23,88.66c2.58,6.06,7.81,9.62,13.27,9.07C80.09,97,83.76,88.66,84,88.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,108.87v33.75H142.38V106.87a132.6,132.6,0,0,1-72.36,22A132.41,132.41,0,0,1,0,108.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.3,
    cy: 44.78,
    r: 6.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.9,38A33.9,33.9,0,0,1,9.46,19,33.75,33.75,0,0,1,14.9.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1.57,171.94A1.5,1.5,0,0,1,0,170.53V148.46a1.77,1.77,0,0,1,1.87-1.68H8.26c3.06,0,6.43,4.44,6.43,7.19,0,1.95-1.57,4.05-3,5.2,1.79,1.15,3.63,3.56,3.63,5.39,0,2.79-3.1,7.38-6.58,7.38Zm6-21.22H4.59v6.65H7.46c1.34,0,2.83-2.14,2.83-3.32S8.87,150.72,7.53,150.72Zm.31,10.4H4.59V168H7.88c1.34,0,2.94-2.1,2.94-3.48S9.14,161.12,7.84,161.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.11,168h7.34a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H21.7a3,3,0,0,1-2.18-2.1v-21a3.08,3.08,0,0,1,2.21-2.1h9.72a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H24.11v6.42h6.27a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H24.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.79,147.62a1.65,1.65,0,0,1,1.53-.84h2.33c1,0,1.26.92.54,2l-7,9.9,7.23,11.21c.42.72.38,2-.58,2H49.16a1.55,1.55,0,0,1-1.6-1l-5.2-8.53-.84,1.19v7.15a1.13,1.13,0,0,1-1.27,1.18h-2.1a1.08,1.08,0,0,1-1.22-1.18V148a1.13,1.13,0,0,1,1.22-1.18h2.1A1.15,1.15,0,0,1,41.52,148v8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.84,168h7.34a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H58.43a3,3,0,0,1-2.18-2.1v-21a3.08,3.08,0,0,1,2.22-2.1h9.71a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H60.84v6.42h6.27a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H60.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.25,168h7.34a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H75.84a3,3,0,0,1-2.18-2.1v-21a3.08,3.08,0,0,1,2.22-2.1h9.71a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H78.25v6.42h6.27a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H78.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.66,171a1,1,0,0,1-1.07,1H92.14a1,1,0,0,1-1.07-1V148.61A2.54,2.54,0,0,1,93,146.78h6.7c2.64,0,6.61,4.86,6.61,7.92s-4,7.87-6.61,7.87h-4Zm3-20.23h-3v7.91h3c1.34,0,3-2.6,3-3.93S100,150.72,98.68,150.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.26,168h7.34a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1h-9.75a3,3,0,0,1-2.18-2.1v-21a3.08,3.08,0,0,1,2.22-2.1h9.71a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1h-7.34v6.42h6.27a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1h-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.65,162.08h-3V171a1,1,0,0,1-1.07,1h-2.45a1,1,0,0,1-1.07-1V148.69a2.44,2.44,0,0,1,2.06-1.91h6.39c2.91,0,6.85,4.59,6.85,7.57,0,1.91-1.8,4.48-3.48,5.51,1.33.76,3.25,2.68,3.25,4.55V171a1,1,0,0,1-1,1h-2.64a1,1,0,0,1-.95-1v-5.89C137.52,163.84,136,162.08,134.65,162.08Zm.27-11.36h-3.25v7.46H135c1.37,0,2.86-2.49,2.86-3.83S136.22,150.72,134.92,150.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.08,
    cy: 44.78,
    r: 6.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.48,38a33.93,33.93,0,0,0,5.43-19A33.77,33.77,0,0,0,127.48.24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkp);
export default __webpack_public_path__ + "static/media/bkp.ce43c90e.svg";
export { ForwardRef as ReactComponent };